module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('van-loading', {
    attrs: {
      "type": "spinner",
      "size": "100px"
    }
  }), _vm._v(" "), _c('p', {
    on: {
      "click": _vm.uploadFacePhoto
    }
  }, [_vm._v("身份核验中...")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-5ab12ad6"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/views/mobile/baiDuFace/MobileVideoFace.vue
// module id = 1156
// module chunks = 41